
import Card from "@/components/base/card/Card"
import FilePreviewCard from "@/components/base/card/FilePreviewCard"
import InfoMaterialUpload from "@/components/region/InfoMaterialUpload"
import { mdiPlus } from "@mdi/js"
import materialService from "@/services/material.service"

export default {
    name: "InfoMaterials",
    components: {
        InfoMaterialUpload,
        FilePreviewCard,
        Card,
    },
    props: {
        /** info materials are loaded for the region with this slug */
        channelSlug: {
            type: String,
            required: true,
        },
        allowEdit: {
            type: Boolean,
            default: true,
        },
    },
    data: () => {
        return {
            files: [],
            showUploadModal: false,
            mdiPlus,
        }
    },
    computed: {
        editable() {
            return this.allowEdit && this.$can.editMaterials(this.channelSlug)
        },
    },
    async created() {
        await this.getInfoMaterials()
    },
    methods: {
        async getInfoMaterials() {
            const response = await materialService.getMaterials(
                this.channelSlug
            )
            this.files = response.data
            this.$emit("change", this.files.length)
        },
    },
}
